import { ToastService } from '../../../components/toasts/Toasts';
'use strict';
angular.module('clientDashboardApp').directive('listingLocationEditor', function ($uibModal, listingService, locationService) {
  return {
    restrict: 'A',
    scope: {
      listing: '=',
      listingMatchConfig: '='
    },
    template:
      '<a class="edit-link pull-right font-weight-bold cursor-pointer"  ng-click="openModal()">Edit Location</a>',
    link: function (scope) {
        scope.openModal = function () {
          let modalInstance = $uibModal.open({
            template: `<div class="modal-header">
                          <h3 class="modal-title">Location Editor</h3>
                        </div>
                        <div class="modal-body" style="margin-top:0">
                          <ng-include src="'angularModules/admin/locations/editor/locationEditorForm.html'"/>
                        </div>
                        <div class="modal-footer mr-3">
                          <ng-include src="'angularModules/admin/locations/editor/locationEditorSubmission.html'"/>
                        </div>`,
            controller: 'LocationsEditorCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              locationId: () => scope.listing.locationId,
              accountId: () => scope.listing.accountId,
              mode: () => 'edit',
              type: () => 'location'
            }
          });

          modalInstance.result.then(function(updated) {
            scope.listingMatchConfig.onLocationUpdate(updated)
            ToastService.success("Updates saved successfully. Reports will refresh to reflect changes within 24 hours.");
          })
        }
      }
   }
});
